import { MILLING_FIELDS } from '../mashStep/constants';

import { getSubStepValues } from '#models/general/steps';
import {
  FROM_0_TO_999_W1_DECIMAL_REGEX,
  FROM_1_TO_8_REGEX,
  NEGATIVES_W1_DECIMAL_REGEX
} from '#utils/string/regex';
import { formatTimeBetweenDates } from '#utils/date';
import Input from '#components/general/Input';
import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';
import { MEASURE_TYPES } from '#components/general/Input/components/Measure/constants';

import { WASH_SCREEN_SET_UP_FIELDS, WASH_SUBSTEPS_IDS } from './constants';

export const getWashScreenSetUpFields = ({ values, errors }) => {
  const getWashScreenSetUpValues = getSubStepValues(WASH_SUBSTEPS_IDS.WASH_SCREEN_SET_UP, values, errors);
  return [
    {
      ...getWashScreenSetUpValues(WASH_SCREEN_SET_UP_FIELDS.WASH_RUN_DATE_AND_TIME),
      Component: Input,
      type: 'datetime-local'
    },
    {
      key: 'ids',
      Component: AdelphiFieldsRow,
      fields: [
        {
          ...getWashScreenSetUpValues(WASH_SCREEN_SET_UP_FIELDS.PERIOD_ID),
          Component: Input,
          disabled: true
        },
        {
          ...getWashScreenSetUpValues(WASH_SCREEN_SET_UP_FIELDS.MASH_ID),
          Component: Input,
          disabled: true
        }
      ]
    },
    {
      ...getWashScreenSetUpValues(WASH_SCREEN_SET_UP_FIELDS.MASH_COMPLETE_DATE_AND_TIME),
      Component: Input,
      type: 'datetime-local',
      value: values?.[MILLING_FIELDS.START_DATE_AND_TIME],
      disabled: true
    },
    {
      key: 'washback',
      Component: AdelphiFieldsRow,
      fields: [
        {
          ...getWashScreenSetUpValues(WASH_SCREEN_SET_UP_FIELDS.WASHBACK_NO),
          Component: Input,
          needsRegex: true,
          customRegex: FROM_1_TO_8_REGEX
        },
        {
          ...getWashScreenSetUpValues(WASH_SCREEN_SET_UP_FIELDS.WASHBACK_TEMP),
          Component: Input,
          measure: MEASURE_TYPES.TEMPERATURE,
          needsRegex: true,
          customRegex: FROM_0_TO_999_W1_DECIMAL_REGEX
        }
      ]
    },
    {
      key: 'tempAndFG',
      Component: AdelphiFieldsRow,
      fields: [
        {
          ...getWashScreenSetUpValues(WASH_SCREEN_SET_UP_FIELDS.WASH_SAMPLE_TEMP),
          Component: Input,
          measure: MEASURE_TYPES.TEMPERATURE,
          needsRegex: true,
          customRegex: FROM_0_TO_999_W1_DECIMAL_REGEX
        },
        {
          ...getWashScreenSetUpValues(WASH_SCREEN_SET_UP_FIELDS.FINAL_GRAVITY),
          Component: Input,
          needsRegex: true,
          customRegex: NEGATIVES_W1_DECIMAL_REGEX
        }
      ]
    },
    {
      ...getWashScreenSetUpValues(WASH_SCREEN_SET_UP_FIELDS.FERMENTATION_TIME),
      Component: Input,
      disabled: true,
      // In the future validate that mash date < wash date
      value: formatTimeBetweenDates(
        values?.[WASH_SCREEN_SET_UP_FIELDS.WASH_RUN_DATE_AND_TIME],
        values?.[WASH_SCREEN_SET_UP_FIELDS.MASH_COMPLETE_DATE_AND_TIME]
      )
    }
  ];
};
